<template>
  <div>
    <b-sidebar
      id="sidebar-add-new-event"
      sidebar-class="sidebar-lg sidebar-calendar-send-news"
      :visible="isEventHandlerSidebarActive"
      bg-variant="white"
      shadow
      no-header
      right
      @change="(val) => $emit('update:is-event-handler-sidebar-active-send-news', val)"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <!-- <h5 class="mb-0">{{ eventLocal._id ? "Atualizar" : "Adicionar" }} Evento</h5> -->
          <h5 class="mb-0">Detalhes</h5>
          <div>
            <feather-icon
              v-if="eventLocal._id"
              icon="TrashIcon"
              class="cursor-pointer"
              @click="
                $emit('remove-event');
                hide();
              "
            />
            <feather-icon
              class="ml-1 cursor-pointer"
              icon="XIcon"
              size="16"
              @click="hide"
            />
          </div>
        </div>
        
        <send-news-tabs
          v-if="isEventHandlerSidebarActive"
          @load-news-data="$emit('load-news-data')"
          @close="$emit('update:is-event-handler-sidebar-active-send-news', false)"
          ></send-news-tabs>
          <!-- @load-news-data="(val) => $emit('load-news-data', val)" -->
          <!-- @close="$emit('update:is-event-handler-sidebar-active-send-news', false)" -->
          <!-- @updated-status-editing="changeToUpdatingFilter"
           -->
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BSidebar,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { required, email, url } from "@validations";
import { toRefs } from "@vue/composition-api";
import SendNewsTabs from '@/views/pages/news/SendNewsTabs.vue';
import useCalendarEventSendNews from './useCalendarEventSendNews';

export default {
  components: {
    BSidebar,
    SendNewsTabs
  },
  directives: {
    Ripple,
  },
  created() {
  },
  model: {
    prop: "isEventHandlerSidebarActive",
    event: "update:is-event-handler-sidebar-active-send-news",
  },
  props: {
    isEventHandlerSidebarActive: {
      type: Boolean,
      required: true,
    },
    newsViewData: {
      type: Object,
    },
  },
  watch: {
    isEventHandlerSidebarActive(val) {
      if (val) {
        this.createSendNewsTab();
      }
    }
  },
  data() {
    return {
      required,
      email,
      url,
    };
  },
  setup(props, { emit }) {
    

    const {
      eventLocal,
      createSendNewsTab,
      // UI
    } = useCalendarEventSendNews(toRefs(props), emit);

    return {
      // Add New Event
      eventLocal,
      createSendNewsTab,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
